import { createActionTypes } from 'sdk/base';

export const sliceName = 'blogApi';
export const ActionTypes = createActionTypes([
    'UPDATE_BLOG_ERROR',
    'UPDATE_BLOGS'
]);

const config = {
    sliceName
};

export default config;
